import { useHead } from '@unhead/react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { TableParamsProvider } from 'business/providers/table-params';
import { DEFAULT_PAGE_SIZE } from 'business/quality-control/constants';
import { SegmentTable } from 'business/quality-control/pages/segment-history/components/segment-table';
import {
  SegmentHistoryFiltersProvider,
  defaultFilters,
} from 'business/quality-control/pages/segment-history/providers/filters';
import { useFilterData } from 'technical/filter-data';

import { MobileSegmentHistoryFilters } from './components/filters';
import { ORDER_FIELD, ORDER_TYPE } from '..';

export interface SegmentHistoryTableFilterData {
  selectedSegments?: number;
}

export function MobileSegmentHistoryPage() {
  const { t } = useTranslation();

  const { filterData, setFilterData } =
    useFilterData<SegmentHistoryTableFilterData>();

  useHead({
    title: t('user.menu.sections.qualityControl.segmentHistory.title'),
  });

  const [searchParams] = useSearchParams();
  const currentSerialNumber = searchParams.get('serialNumber');

  return (
    <TableParamsProvider
      defaultPageSize={DEFAULT_PAGE_SIZE}
      defaultSortField={ORDER_FIELD}
      defaultSortOrder={ORDER_TYPE}
    >
      <SegmentHistoryFiltersProvider
        initialFilters={{
          ...defaultFilters,
          serialNumber: currentSerialNumber ?? defaultFilters.serialNumber,
        }}
      >
        <MobileSingleCardPageWithFilterLayout
          title={t('user.menu.sections.qualityControl.segmentHistory.title')}
          filters={<MobileSegmentHistoryFilters filterData={filterData} />}
          // Disable while the scan feature is slow with barcode
          // corner={<MobileSegmentHistoryHeader />}
        >
          <SegmentTable setFilterData={setFilterData} mobile />
        </MobileSingleCardPageWithFilterLayout>
      </SegmentHistoryFiltersProvider>
    </TableParamsProvider>
  );
}
